import { styled } from '@material-ui/core/styles';
import { DSTheme } from '../themes/types';

const Paper = styled('div')(({ theme }: { theme: DSTheme }) => ({
  display: 'grid',
  gridGap: '32px',

  background: theme.palette.background.elevation1,
  boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
  borderRadius: '16px',

  marginTop: '40px',
  padding: '32px',
  minWidth: '500px',
  maxWidth: '528px',
  color: theme.palette.text.description,

  [theme.breakpoints.up('md')]: {
    maxWidth: '894px',
  },
}));

export default Paper;
